import React from 'react';
import { N01HeaderProps } from './N01Header.types';
import { Header } from '@ahc-digital/component-library';
import { GetHeaderModel } from './N01Header.service';
import { PromptForMissingDatasource } from 'src/shared/PromptForMissingDatasource';
import { useCustomSitecoreContext } from 'src/shared/useCustomSitecoreContext';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';

export const Default = (props?: N01HeaderProps): JSX.Element => {
  const context = useCustomSitecoreContext();
  const disableElasticSearch = context?.disableElasticSearch?.value;
  const searchPageUrl = disableElasticSearch ? '' : context?.defaultSearchPage?.value;
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  if (!props?.rendering?.dataSource)
    return <PromptForMissingDatasource rendering={props?.rendering} />;

  return (
    <Header
      data-elastic-exclude=""
      data-component={marketingRenderingName}
      {...GetHeaderModel(props, searchPageUrl || '')}
    />
  );
};
